"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BadgesFilter = void 0;
var _node = require("@domain-group/fe-allhomes-library/lib/node");
var _multiValueSearchQueryField = require("../multi-value-search-query-field");
var _parseSlugs = require("../../utils/parse-slugs");
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class BadgesFilter extends _multiValueSearchQueryField.MultiValueSearchQueryField {
  constructor(searchOptions, values) {
    var defaultSelected = searchOptions.searchType === 'new-price' ? [_node.ListingBadge.priceReduced.name] : [];
    super(searchOptions, Object.values(_node.ListingBadge), [...defaultSelected, ...(values || [])], defaultSelected);
    _defineProperty(this, "urlSlug", BadgesFilter.urlSlug);
  }
  static fromUrlParameters(searchOptions, q) {
    return new BadgesFilter(searchOptions, (0, _parseSlugs.parseSlugs)(_node.ListingBadge, q[BadgesFilter.urlSlug]));
  }
}
exports.BadgesFilter = BadgesFilter;
_defineProperty(BadgesFilter, "urlSlug", 'badges');